<template>
  <div :id="id" :style="`height:${height};`"></div>
</template>

<script>
  import * as echarts from 'echarts'

  export default {
    name: 'Echart05',
    props: ['id', 'height', 'datas', 'colors', 'radius'],
    data() {
      return {

      }
    },
    watch: {
      datas: {
        deep: true,
        handler: function(newV, oldV) {
          if (!newV) return
          this.draw()
        }
      }
    },
    mounted() {
      if (Object.keys(this.datas).length !== 0) {
        this.draw()
      }
    },
    methods: {
      draw() {
        if (document.getElementById(this.id) == null) {
          return
        }
        echarts.dispose(document.getElementById(this.id))
        const myChart = echarts.init(document.getElementById(this.id))
        let option = {
          color: this.colors,
          grid: {
            containLabel: true
          },
          tooltip: {
            trigger: 'item'
          },
          // title: {
          //   text: "Main Title",
          //   left: "center",
          //   top: '50%',
          //   textStyle: {
          //     fontSize: 12
          //   }
          // },
          legend: {
            itemWidth: 16,
            itemHeight: 8,
            textStyle: {
              color: 'rgba(255, 255, 255, .8)',
              fontSize: 10,
            },
            padding: [24, 20, 0, 20]
          },
          // calculable: true,
          series: [{
            type: 'pie',
            radius: this.radius || ['30%', '50%'],
            top: 20,
            // avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 3,
              borderColor: '#08103c',
              borderWidth: 2
            },
            label: {
              // alignTo: 'edge',
              color: 'rgba(255, 255, 255, .8)',
              // formatter: '{c|{b}}\n{d|{d}%}',
              formatter: '{d|{d}%}\n{c|{c}}',
              // minMargin: 5,
              // edgeDistance: 10,
              // lineHeight: 15,
              rich: {
                c: {
                  fontSize: 10,
                  color: '#999'
                }
              }
            },
            labelLine: {
              // length: 15,
              // length2: 0,
              // maxSurfaceAngle: 80
            },
            data: this.datas
          }]
        }
        myChart.setOption(option, true)
      }
    }
  }
</script>

<style>
</style>
